import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceDiscountConceptTableModel } from 'src/app/models/tables/invoicing/Invoice-discount-concept-table.model';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { InvoiceDetailService } from 'src/app/services/invoicing/invoice-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoiceEnums } from './../../../../enum/invoice-enums';
import { InvoiceConceptModel } from './../../../../models/invoicing/invoice-concept.model';
import { InvoiceModel } from './../../../../models/invoicing/invoice.model';
import { InvoiceConceptService } from './../../../../services/invoicing/invoice-concept.service';

@Component({
  selector: 'app-list-invoice-concept',
  templateUrl: './list-invoice-concept.component.html',
  styleUrls: ['./list-invoice-concept.component.scss'],
  standalone: false
})
export class ListInvoiceConceptComponent implements OnInit {
  ascendant: boolean = true;
  columnSort: string | null = null;
  data: PagedResponseModel<InvoiceDiscountConceptTableModel> = new PagedResponseModel<InvoiceDiscountConceptTableModel>();
  disabledActions: boolean = false;
  formInvoiceConcept: FormGroup = new FormGroup({});
  header: ColumnResponseModel[] = [];
  invoiceModel: InvoiceModel = new InvoiceModel();
  invoiceConceptModel: InvoiceConceptModel = new InvoiceConceptModel();
  isFormView: boolean = false;
  limit: number = 10;
  listConceptInvoicing: any[] = [];
  page: number = 1;
  permissionUpdatable: boolean = false;
  suscription: Subscription;
  tableActions: TableAction[] = [];
  updateInvoice: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private invoiceDetailService: InvoiceDetailService,
    private invoiceConceptService: InvoiceConceptService,
    private toastHandlerService: ToastHandlerService,
    public config: DynamicDialogConfig,
    @Optional() private ref: DynamicDialogRef) {
  }

  async ngOnInit(): Promise<void> {
    this.validateForm(new InvoiceConceptModel());
    await this.getColumns();
    await this.getlistConceptInvoicing();

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.invoiceModel = inputs.invoiceModel;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.disabledActions = inputs.disabledForm;
    });

    await this.getInvoiceConceptsByInvoiceIdWithPagination();
    this.tableActions = this.getDefaultActions();
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async cancel() {
    this.invoiceConceptModel = new InvoiceConceptModel();
    this.validateForm(this.invoiceConceptModel);
    this.isFormView = false;
  }

  changeDiscountRate() {
    const form = this.formInvoiceConcept;

    const discountRate = form.get('discountRate')?.value ?? 0;
    const value = form.get('value')?.value ?? 0;

    if (discountRate > 100) {
      this.toastHandlerService.showToast(
        'warning',
        'El porcentaje del descuento no puede ser superior a 100.',
        'Atención'
      );

      this.formInvoiceConcept.get("discountRate")?.patchValue(0);
      this.formInvoiceConcept.get("discountValue")?.patchValue(0);
      return;
    }

    form.patchValue({
      discountRate,
      discountValue: discountRate > 0 ? (value * discountRate) / 100 : 0
    });
  }

  changeDiscountValue() {
    const form = this.formInvoiceConcept;

    const discountValue = form.get('discountValue')?.value ?? 0;
    const value = form.get('value')?.value ?? 0;

    if (discountValue > value) {
      this.toastHandlerService.showToast(
        'warning',
        'El valor del descuento no puede ser superior al valor del Concepto.',
        'Atención'
      );
      this.formInvoiceConcept.get("discountRate")?.patchValue(0);
      this.formInvoiceConcept.get("discountValue")?.patchValue(0);
      return;
    }

    const discountRate = discountValue > 0 ? (discountValue / value) * 100 : 0;

    form.patchValue({
      discountRate,
      discountValue
    });
  }

  close() {
    const data: ModalObjectType = {};
    data.params = { updateInvoice: this.updateInvoice };
    this.ref.close(data);
  }

  async createNew() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear códigos ciudades.
          Comuníquese con el administrador del sistema.`);
      return;
    }
    this.getFormView(true);
  }

  async getColumns() {
    try {
      this.header = await firstValueFrom(this.invoiceConceptService.getColumnsForInvoiceDiscountConceptAsync());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    if (this.invoiceModel.invoiceStateId == InvoiceEnums.abierta) {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    } else {
      return [];
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getInvoiceConceptsByInvoiceIdWithPagination() {
    try {
      this.data = await firstValueFrom(this.invoiceConceptService.getInvoiceConceptsByInvoiceIdWithPagination(this.page, this.limit, this.columnSort, this.ascendant,
        this.invoiceModel.invoiceId));
    } catch (error) {
      console.error('Error al buscar los conceptos.', error);
    }
  }

  async getlistConceptInvoicing() {
    try {
      this.listConceptInvoicing = await firstValueFrom(this.invoiceDetailService.getAllConceptInvoicingForSelectAsync());
    } catch (error) {
      console.error('Error al obtener la lista de conceptos.', error);
    }
  }

  async onAction(event: { action: string, item?: InvoiceDiscountConceptTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      try {
        this.invoiceConceptModel = await firstValueFrom(this.invoiceConceptService.getInvoiceConceptById(event.item.id));
        this.validateForm(this.invoiceConceptModel);
        this.isFormView = true;
      } catch (error) {
        console.error('Error to edit repair:', error);
      }
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getInvoiceConceptsByInvoiceIdWithPagination();
  }

  setForm(): any {
    this.invoiceConceptModel.invoiceConceptId = this.formInvoiceConcept.get("conceptInvoicingId")?.value;
    this.invoiceConceptModel.conceptInvoicingId = this.formInvoiceConcept.get("conceptInvoicingId")?.value;
    this.invoiceConceptModel.discountRate = this.formInvoiceConcept.get("discountRate")?.value;
    this.invoiceConceptModel.discountValue = this.formInvoiceConcept.get("discountValue")?.value;
    return this.invoiceConceptModel;
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      discountRate: {
        min: 'Debe ingresar un descuento válido'
      },
      discountValue: {
        min: 'Debe ingresar un valor descuento válido'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formInvoiceConcept.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async send() {
    this.validateFormControls();
    if (this.formInvoiceConcept.valid) {
      const modelInvoiceConcept = this.setForm();
      try {
        await firstValueFrom(this.invoiceConceptService.saveGeneralDiscount(modelInvoiceConcept));
        this.getInvoiceConceptsByInvoiceIdWithPagination();
        this.validateForm(new InvoiceConceptModel);
        this.updateInvoice = true;
        this.isFormView = false;
        this.toastHandlerService.showToast('success', 'El concepto se modifico exitosamente.', '');
      } catch (error) {
        console.error('Error al guardar el descuento general', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  validateForm(invoiceConcept: InvoiceConceptModel) {
    this.formInvoiceConcept = this.formBuilder.group({
      conceptInvoicingId: [invoiceConcept.conceptInvoicingId, [Validators.required]],
      value: [invoiceConcept.value, [Validators.required]],
      discountRate: [invoiceConcept.discountRate, [Validators.required, Validators.min(0)]],
      discountValue: [invoiceConcept.discountValue, [Validators.required, Validators.min(0)]],
    });

    this.formControlStateService.setControlState(this.formInvoiceConcept, ['conceptInvoicingId', 'value'], false);
  }

  validateFormControls() {
    Object.keys(this.formInvoiceConcept.controls).forEach((key) => {
      const control = this.formInvoiceConcept.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
